import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { NavHashLink as Link } from 'react-router-hash-link';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Dropdown from 'react-bootstrap/Dropdown';
import Container from 'react-bootstrap/Container';
import LanguageIcon from '@material-ui/icons/Language';

const NavbarMain = () => {
	const { t, i18n } = useTranslation();

	const [collapsed, setCollapsed] = useState(false)

	const toggleNavbar = () => {
		setCollapsed(!collapsed);
	}

	useEffect(() => {
		const Navlinks = document.querySelectorAll('.nav-link:not(.dropdown-toggle)')
		for (var i = 0; i < Navlinks.length; i++) {
			Navlinks[i].addEventListener('click', () => {
				setCollapsed(false);
			}, false);

			//replace pre slash in navlinks. Otherwise link highlighing doesn't work
			const href = Navlinks[i].getAttribute('href');
			const regEx = /^\//
			const strippedHref = href.replace(regEx, '')
			Navlinks[i].setAttribute('href', strippedHref)
		}

	}, [])

	const BlogNavs = (() => {

		let blogNavs = []

		for (let i = 1; i <= 6; i++) {
			blogNavs.push(
				<Nav.Item key={`blog-link-${i}`}>
					<Link className={`nav-link blog-nav-item blog-link-${i}`} to={{
						pathname: '/blog-details',
						state: {
							blogId: i
						}
					}}>
						{t(`blog title ${i}`)}
					</Link>
				</Nav.Item>
			)
		}

		return blogNavs
	})()

	return (
		<Navbar expand="lg" fixed="top" collapseOnSelect expanded={collapsed} className="theme-nav" >
			<Container>
				<Navbar.Brand as={Link} smooth to="/#home">
					<img style={{ maxHeight: '3rem' }} src={`${process.env.PUBLIC_URL}/assets/images/ourmind-logo-h.png`} alt="logo" />
				</Navbar.Brand>
				<Navbar.Toggle onClick={() => {
					toggleNavbar();
				}}>
				</Navbar.Toggle>
				<Navbar.Collapse id="navbarSupportedContent" className="default-nav">
					<Nav className="ml-auto" navbar id="mymenu">
						<Nav.Item key="home">
							<Nav.Link as={Link} smooth to="/#home">
								{t('home')}
							</Nav.Link>
						</Nav.Item>
						<Nav.Item key="about">
							<Nav.Link as={Link} smooth to="/#about">
								{t('about')}
							</Nav.Link>
						</Nav.Item>
						<Nav.Item key="features">
							<Nav.Link as={Link} smooth to="/#feature">
								{t('features')}
							</Nav.Link>
						</Nav.Item>
						<Nav.Item className="d-lg-none" key="blog-sm">
							<Nav.Link as={Link} smooth to="/#blog">
								{t('use cases')}
							</Nav.Link>
						</Nav.Item>
						<Dropdown as={Nav.Item} key="blog-md" id="blog-md">
							<Dropdown.Toggle as={Link} smooth to="/#blog" className="d-none d-lg-block use-cases nav-link">
								{t('use cases')}
							</Dropdown.Toggle>
							<Dropdown.Menu>
								{BlogNavs}
							</Dropdown.Menu>

						</Dropdown>
						<Nav.Item key="blog">
							<Nav.Link as={Link} smooth to="/blog">
								{t('blog')}
							</Nav.Link>
						</Nav.Item>
						<Nav.Item key="price">
							<Nav.Link as={Link} smooth to="/#price">
								{t('price')}
							</Nav.Link>
						</Nav.Item>
						<Nav.Item key="contactPage">
							<Nav.Link as={Link} smooth to="/contact">
								{t('contactNav')}
							</Nav.Link>
						</Nav.Item>
						<NavDropdown key="lang-sel" title={[<LanguageIcon style={{ marginTop: '-0.15rem' }} fontSize="small" className="mr-1" />, t('lang name')]}>
							<Nav.Item key="lang-en">
								<Nav.Link onClick={() => i18n.changeLanguage('en-US')}>
									English
									</Nav.Link>
							</Nav.Item>
							<Nav.Item key="lang-fi">
								<Nav.Link onClick={() => i18n.changeLanguage('fi-FI')}>
									Suomi
									</Nav.Link>
							</Nav.Item>
							{/* 							<Nav.Item key="lang-sv">
								<Nav.Link onClick={() => i18n.changeLanguage('sv-SE')}>
									Svenska
									</Nav.Link>
							</Nav.Item> */}
						</NavDropdown>
					</Nav>
				</Navbar.Collapse>
			</Container>
		</Navbar>
	);
}

export default NavbarMain;


// WEBPACK FOOTER //
// ./src/components/navbar.js